/*
 * TODO: I couldn't found sui in caip
 * @see https://namespaces.chainagnostic.org/
 */

// if the value neeeds to be change make sure you will update mapCaipNamespaceToLegacyNetworkName as well
export const CAIP_NAMESPACE = 'sui';
export const CAIP_SUI_CHAIN_ID = 'sui';
